import React from 'react';
import { Navigate,Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './pages/Home';

// import Login from './pages/forms/Login';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import MemberLogin from './components/forms/MemberLogin';
import Candidatelogin from './components/forms/CandiLogin';
import Register from './components/forms/Register';
import JoinUs from './pages/JoinUs';
import Spotlight from './pages/Spolight';
import Chapter from './pages/Chapter';
import Profile from './pages/Profile';
import PollQ from './pages/PollQ';
import ViewTest from './pages/ViewTest';
import InsViewTest from './pages/InstituteViewTest';
import BatchPage from './pages/BatchPage';
import PreTest from './pages/Pretest';
import InstituteTests from './pages/InstituteTests';

function App() {
  return (
    <Router>
       
      <div>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/Login" element={<Login />} /> */}
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/MemberLogin" element={<MemberLogin />} />
          <Route path="/Candidatelogin" element={<Candidatelogin />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Spotlight" element={<Spotlight />} />
          <Route path="/JoinUs" element={<JoinUs />} />
          <Route path="/Chapter" element={<Chapter />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/PollQ" element={<PollQ />} />
          <Route path="/ViewTest" element={<ViewTest />} />
          <Route path="/ViewTest/:testId" element={<ViewTest />} /> {/* Updated route */}
          <Route path="/InsViewTest" element={<InsViewTest />} />
          <Route path="/InsViewTest/:testId" element={<InsViewTest />} />
          <Route path="/batch/:batchCode" element={<BatchPage />} />
          <Route path="/InstituteTests" element={<InstituteTests />} />
          <Route path="/PreTest" element={<PreTest />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}
export default App;




